import { LogLevel } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID || '7ff9c5d1-aca6-4cec-840a-269f59d243ed', // This is the ONLY mandatory field that you need to supply.
        authority: process.env.REACT_APP_AZURE_AD_AUTHORITY || 'https://rfinetad.b2clogin.com/rfinetad.onmicrosoft.com/B2C_1A_signup_signin_RP22', // Replace with your B2C authority
        knownAuthorities: [process.env.REACT_APP_AZURE_AD_KNOWN_AUTHORITY || 'rfinetad.b2clogin.com'], // Mark your B2C tenant's domain as trusted.
        redirectUri: process.env.REACT_APP_AZURE_AD_REDIRECT_URI || '/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: process.env.REACT_APP_AZURE_AD_POST_LOGOUT_REDIRECT_URI || '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ['openid', 'profile', 'offline_access', process.env.REACT_APP_AZURE_AD_API_SCOPE || 'https://rfinetAD.onmicrosoft.com/apiv2/read']
};

/**
 * Token request used by the axios interceptor to silently acquire an access
 * token scoped to the App.WebApi (clientId: 5ddef939-599c-40d6-acc1-f44baf4b1e1d).
 * Only API scopes should be listed here – no OIDC scopes.
 */
export const apiRequest = {
    scopes: [process.env.REACT_APP_AZURE_AD_API_SCOPE || 'https://rfinetAD.onmicrosoft.com/apiv2/read']
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
    scopes: ['openid', 'profile'],
    loginHint: 'example@domain.net'
};
